import { FORM_NAMES } from "constants/index"
import React, { useRef, useState, useEffect, useLayoutEffect } from "react"
import { connect } from "react-redux"
import {
  Col,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
  NavLink,
} from "reactstrap"
import { FormSection, formValueSelector } from "redux-form"
import { LOADING_SCREEN_TABS, WIDTH_TYPES } from "./constants"
import LoadingScreenBackground from "./loading-screen-background"
import LoadingScreenLogo from "./loading-screen-logo"
import { LoadingScreeenPreview } from "./previews"
const LoadingScreenSetup = ({
  loadingScreen,
  isActive,
  logoImage,
  widthInPercent,
  widthInPixel,
  widthType,
  logoPlacement,
  handleNext,
  handleSave,
  setSubTabBreadcrumb,
}) => {
  const [activeTab, setActiveTab] = useState(LOADING_SCREEN_TABS.BACKGROUND)
  const [logoHeight, setLogoHeight] = useState(0)
  const [logoMargin, setLogoMargin] = useState(0)
  const [logoImageDimensions, setLogoImageDimensions] = useState([0, 0])

  const [windowsSize, setWindowsSize] = useState([0, 0])
  const [colSize, setColSize] = useState([0, 0])
  let resizeTimeout = null
  const colRef = useRef()
  const [translateValue, setTranslateValue] = useState(0)

  useLayoutEffect(() => {
    const updateSize = () => {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout)
      }
      resizeTimeout = setTimeout(() => {
        setWindowsSize([window.innerWidth, window.innerHeight])
      }, 500)
    }

    window.addEventListener("resize", updateSize)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      if (colRef?.current) {
        setColSize([colRef.current.clientWidth, colRef.current.clientHeight])
      }
    }, 900)
  }, [colRef, windowsSize])

  useEffect(() => {
    if (isActive) {
      setActiveTab(LOADING_SCREEN_TABS.BACKGROUND)
      setSubTabBreadcrumb("Background", () => {
        setActiveTab(LOADING_SCREEN_TABS.BACKGROUND)
      })
    }
    setTimeout(() => {
      if (colRef?.current) {
        setColSize([colRef.current.clientWidth, colRef.current.clientHeight])
      }
    }, 500)
  }, [isActive])

  const MOBILE_SCALE = 0.5
  const MOBILE_HEIGHT = 1000 * MOBILE_SCALE
  const MOBILE_WIDTH = 427 * MOBILE_SCALE

  useEffect(() => {
    setTranslateValue((colSize[0] - 24) / 2 - MOBILE_WIDTH / 2)
  }, [colSize])

  useEffect(() => {
    if (logoImage && logoImage?.editedImage) {
      const img = document.createElement("img")
      img.id = "imgId"
      img.style = "visibility: hidden"
      img.src = logoImage?.editedImage
      img.addEventListener("load", ({ target }) => {
        setLogoImageDimensions([target.clientWidth, target.clientHeight])
        if (widthType === "PIXEL") {
          setLogoHeight(
            (widthInPixel * target.clientHeight) / target.clientWidth
          )
        } else if (widthType === "PERCENTAGE") {
          setLogoHeight(
            (target.clientWidth *
              (widthInPercent / 100) *
              target.clientHeight) /
              target.clientWidth
          )
        } else {
          setLogoHeight(target.clientHeight)
        }
        target.remove()
      })
      document.body.appendChild(img)
    }
  }, [logoImage])

  useEffect(() => {
    if (widthType === "PIXEL") {
      setLogoHeight(
        (widthInPixel * logoImageDimensions[1]) / logoImageDimensions[0]
      )
    } else if (widthType === "PERCENTAGE") {
      setLogoHeight(
        (375 * (widthInPercent / 100) * logoImageDimensions[1]) /
          logoImageDimensions[0]
      )
    } else {
      setLogoHeight((375 * logoImageDimensions[1]) / logoImageDimensions[0])
    }
  }, [widthInPercent, widthInPixel, widthType, logoImageDimensions])

  useEffect(() => {
    setLogoMargin((logoPlacement * (812 - logoHeight)) / 100)
  }, [logoHeight, logoPlacement])

  useEffect(() => {
    setSubTabBreadcrumb(activeTab === 1 ? "Background" : "Logo", () => {
      setActiveTab(LOADING_SCREEN_TABS.BACKGROUND)
    })
  }, [activeTab])

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  return (
    <Row>
      <Col xl={8}>
        <Row className="my-3">
          <Col xs="auto ms-5">
            <Nav pills className="flex-column">
              <NavItem>
                <NavLink
                  className={markIfIsActive(LOADING_SCREEN_TABS.BACKGROUND)}
                  onClick={() => setActiveTab(LOADING_SCREEN_TABS.BACKGROUND)}
                >
                  {<span style={{ fontSize: "16px" }}>Background</span>}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={markIfIsActive(LOADING_SCREEN_TABS.LOGO)}
                  onClick={() => setActiveTab(LOADING_SCREEN_TABS.LOGO)}
                >
                  {<span style={{ fontSize: "16px" }}>Logo</span>}
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
          <Col>
            <TabContent
              activeTab={activeTab}
              className="text-muted mt-4 mt-md-0"
            >
              <TabPane
                style={{ animation: "none" }}
                tabId={LOADING_SCREEN_TABS.BACKGROUND}
              >
                <FormSection name="background">
                  <LoadingScreenBackground
                    changeTab={() => {
                      setActiveTab(LOADING_SCREEN_TABS.LOGO)
                    }}
                    tabIsActive={
                      activeTab === LOADING_SCREEN_TABS.BACKGROUND && isActive
                    }
                    handleSave={handleSave}
                  />
                </FormSection>
              </TabPane>
              <TabPane
                style={{ animation: "none" }}
                tabId={LOADING_SCREEN_TABS.LOGO}
              >
                <FormSection name="logo">
                  <LoadingScreenLogo
                    changeTab={() => {
                      setActiveTab(LOADING_SCREEN_TABS.BACKGROUND)
                    }}
                    handleNext={handleNext}
                    tabIsActive={
                      activeTab === LOADING_SCREEN_TABS.LOGO && isActive
                    }
                    handleSave={handleSave}
                  />
                </FormSection>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </Col>
      <div
        ref={colRef}
        className="col-xl-4 mt-3 d-none d-xl-block "
        style={{ height: `${MOBILE_HEIGHT}px` }}
      >
        <h5 style={{ textAlign: "center" }}>Preview</h5>
        <div
          style={{
            transform: `translate(${translateValue}px, 0)`,
          }}
        >
          <LoadingScreeenPreview
            loadingScreen={loadingScreen || {}}
            scale={MOBILE_SCALE}
            logoMargin={logoMargin}
          />
        </div>
      </div>
    </Row>
  )
}

const selector = formValueSelector(FORM_NAMES.ONBOARDING_FLOW_WIZARD)

const mapStateToProps = state => ({
  loadingScreen: selector(state, "loadingScreen"),
  logoImage: selector(state, "loadingScreen.logo.logoImage"),
  widthType: selector(state, "loadingScreen.logo.widthType"),
  widthInPixel: selector(state, "loadingScreen.logo.widthInPixel"),
  widthInPercent: selector(state, "loadingScreen.logo.widthInPercent"),
  logoPlacement: selector(state, "loadingScreen.logo.logoPlacement"),
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(LoadingScreenSetup)
